import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SwUpdatePrompt from "@/components/SwUpdatePrompt";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { CompareProvider } from "@/context/CompareContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import BroadcastBar from "@/components/BroadcastBar";
import BannerBar from "@/components/BannerBar";
import CompareBar from "@/components/CompareBar";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import PropertyDetail from "@/pages/PropertyDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AdminLogin from "@/pages/AdminLogin";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import BrokerDashboard from "@/pages/BrokerDashboard";
import PropertyForm from "@/pages/PropertyForm";
import AdminDashboard from "@/pages/AdminDashboard";
import Terms from "@/pages/Terms";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import GrievanceRedressal from "@/pages/GrievanceRedressal";
import RefundPolicy from "@/pages/RefundPolicy";
import NotFound from "@/pages/NotFound";
import Launch from "@/pages/Launch";
import ChooseRole from "@/pages/ChooseRole";
import Account from "@/pages/Account";
import Promo from "@/pages/Promo";
import HomeLoans from "@/pages/HomeLoans";
import LoanProviderApply from "@/pages/LoanProviderApply";

function Shell({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-brand-page overflow-x-hidden">
      <BannerBar />
      <Navbar />
      <BroadcastBar />
      <main className="flex-1">{children}</main>
      <Footer />
      <ChatWidget />
      <CompareBar />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <SettingsProvider>
          <CompareProvider>
            <BrowserRouter>
              <Toaster position="bottom-right" richColors />
              <SwUpdatePrompt />
              <Routes>
                <Route path="/" element={<Shell><Home /></Shell>} />
                <Route path="/browse" element={<Shell><Browse /></Shell>} />
                <Route path="/property/:id" element={<Shell><PropertyDetail /></Shell>} />
                <Route path="/terms" element={<Shell><Terms /></Shell>} />
                <Route path="/privacy" element={<Shell><PrivacyPolicy /></Shell>} />
                <Route path="/grievance" element={<Shell><GrievanceRedressal /></Shell>} />
                <Route path="/refund" element={<Shell><RefundPolicy /></Shell>} />
                <Route path="/promo/:slug" element={<Shell><Promo /></Shell>} />
                <Route path="/home-loans" element={<Shell><HomeLoans /></Shell>} />
                <Route path="/list-your-loan-service" element={<Shell><LoanProviderApply /></Shell>} />
                <Route path="/login" element={<Shell><Login /></Shell>} />
                <Route path="/register" element={<Shell><Register /></Shell>} />
                <Route path="/forgot-password" element={<Shell><ForgotPassword /></Shell>} />
                <Route path="/reset-password" element={<Shell><ResetPassword /></Shell>} />
                <Route path="/admin/login" element={<Shell><AdminLogin /></Shell>} />
                <Route path="/launch" element={<Launch />} />
                <Route path="/choose-role" element={<ProtectedRoute><Shell><ChooseRole /></Shell></ProtectedRoute>} />
                <Route path="/account" element={<ProtectedRoute roles={["customer", "broker", "owner"]}><Shell><Account /></Shell></ProtectedRoute>} />
                <Route path="/broker" element={<ProtectedRoute roles={["broker", "owner"]}><Shell><BrokerDashboard /></Shell></ProtectedRoute>} />
                <Route path="/broker/property/new" element={<ProtectedRoute roles={["broker", "owner"]}><Shell><PropertyForm /></Shell></ProtectedRoute>} />
                <Route path="/broker/property/:id/edit" element={<ProtectedRoute roles={["broker", "owner"]}><Shell><PropertyForm /></Shell></ProtectedRoute>} />
                <Route path="/admin/property/new" element={<ProtectedRoute roles={["admin", "subadmin"]}><Shell><PropertyForm /></Shell></ProtectedRoute>} />
                <Route path="/admin/property/:id/edit" element={<ProtectedRoute roles={["admin", "subadmin"]}><Shell><PropertyForm /></Shell></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute roles={["admin", "subadmin"]}><Shell><AdminDashboard /></Shell></ProtectedRoute>} />
                <Route path="*" element={<Shell><NotFound /></Shell>} />
              </Routes>
            </BrowserRouter>
          </CompareProvider>
        </SettingsProvider>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
